import "./VideoProductionInSaoPaulo.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import SiteStructure from "./sections/SiteStructure";
import DetailedServiceList from "./sections/DetailedServiceList";
import TheGalaxyStandard from "./sections/TheGalaxyStandard";
import GlobalAvailability from "./sections/GlobalAvailability";
import ReserveYourExperience from "./sections/ReserveYourExperience";
import Footer from "@/reusable_sections/Footer";
export default function VideoProductionInSaoPauloPage() {
  return <div>
      <Header />
      <Hero />
      <SiteStructure />
      <DetailedServiceList />
      <TheGalaxyStandard />
      <GlobalAvailability />
      <ReserveYourExperience />
      <Footer />
    </div>;
}